import { DataSource, DataSourceMode, ValidationResult } from "@mcleod/components";
import { ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutShipperPONums } from "./autogen/AutogenLayoutShipperPONums";

interface ShipperPONumsProps {
    stopSource: DataSource,
    firstStopRow: ModelRow
}

export class ShipperPONums extends AutogenLayoutShipperPONums {
    initialize(props: ShipperPONumsProps) {
        this.visible = true;
        this.textboxShipperPONums.dataSource = props.stopSource;
        this.textboxShipperPONums.displayData(props.firstStopRow, props.stopSource.data, 0);
        this.textboxShipperPONums.updateBoundData(props.firstStopRow, props.stopSource.mode);
        this.textboxShipperPONums.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
            return this.validateShipperPONums(mode);
        };
        this.textboxShipperPONums.addBlurListener(() => {
            props.firstStopRow.set("clear_po_nums", StringUtil.isEmptyString(this.textboxShipperPONums.text));
            this.textboxShipperPONums.updateBoundData(props.firstStopRow, props.stopSource.mode);
        });
    }

    /**
     * Validates the Shipper PO Numbers input field.
     *
     * Validation is performed only when the mode is not SEARCH.
     * The input must follow these rules:
     * - One or more reference numbers separated by commas (e.g., "12345,67890,abc-de")
     * - Each reference number may contain letters, numbers, spaces, hyphens (-),
     *   underscores (_), hash (#), forward slashes (/), and backslashes (\)
     * - Each reference number must be between 1 and 32 characters
     * - No leading, trailing, or consecutive commas
     *
     * @param {DataSourceMode} mode - The current mode of the data source.
     * @returns {ValidationResult | null} A validation failure result, or null if valid or in SEARCH mode.
     */
    private validateShipperPONums(mode: DataSourceMode): ValidationResult {
        if (mode === DataSourceMode.SEARCH) {
            return null;
        }
        const regex = /^([ 0-9a-zA-Z-_#/\\]{1,32},)*[ 0-9a-zA-Z-_#/\\]{1,32}$|^$/;
        if (!regex.test(this.textboxShipperPONums.text)) {
            return {
                component: this.textboxShipperPONums,
                isValid: false,
                validationMessage: "Please enter reference numbers (up to 32 characters) delimited by commas. Only letters, numbers, spaces, hyphens (-), underscores (_), hash (#), forward slashes (/), and backslashes (\\) are allowed."
            };
        }
        else {
            return null;
        }
    }
}
